import type { FacetsDTO } from '@empathyco/playboard-core-domain'
import { DomainEnum } from '@empathybroker/tsclient-play/dist/enums/domain.enum'
import { EndpointContextEnum } from '../enums'

export interface FacetsBrowseListParams {
  field: string
  value: string
  context: string
}

export function isBrowseLikeFacetsConfig(
  item: Pick<FacetsDTO, 'endpointId' | 'config'>,
  endpointContext?: string,
): boolean {
  return (
    item.endpointId === DomainEnum.BROWSE ||
    item.config?.context === DomainEnum.BROWSE.toUpperCase() ||
    endpointContext === EndpointContextEnum.FILTER
  )
}

export function getFacetsBrowseContextLabel(
  context: FacetsDTO['criteria']['context'],
): string | undefined {
  const label = context?.map(item => item.values.join(' > ')).join(' > ')
  return label || undefined
}

export function getFacetsBrowseListParams(
  item: FacetsDTO,
  endpointContext?: string,
): FacetsBrowseListParams | undefined {
  if (!isBrowseLikeFacetsConfig(item, endpointContext)) {
    return undefined
  }

  const field = item.criteria.context?.[0]?.values[0]
  const value = item.criteria.context?.[1]?.values[0]
  if (!field || !value) {
    return undefined
  }

  return {
    field,
    value,
    context: DomainEnum.BROWSE,
  }
}
